import { SupplierName, BARCODE_RULES, BarcodeRule } from "../utils/constants";

export type BarcodeInformation =
  | {
      isValid: true;
      matchedSuppliers: SupplierName[];
      supplierName: SupplierName | null;
      serialNumber: string;
    }
  | {
      isValid: false;
      matchedSuppliers: SupplierName[];
      supplierName: null;
      serialNumber: null;
    };

// The serial number is the matching pattern's capture group when it has one (codes that
// encode more than the serial number), otherwise the whole barcode.
const extractSerialNumber = (barcode: string, rules: BarcodeRule[]): string => {
  const match = rules
    .flatMap((rule) => rule.patterns)
    .map((pattern) => pattern.exec(barcode))
    .find((result) => result !== null);

  return match?.[1] ?? match?.[0] ?? barcode;
};

export const useBarcodeInformation = (): {
  processBarcode: (barcode: string) => BarcodeInformation;
} => {
  const processBarcode = (barcode: string): BarcodeInformation => {
    const matchedRules = BARCODE_RULES.filter((rule) =>
      rule.patterns.some((pattern) => pattern.test(barcode)),
    );
    const matchedSuppliers = matchedRules.map((rule) => rule.supplier);

    if (matchedSuppliers.length === 0) {
      return { isValid: false, matchedSuppliers, supplierName: null, serialNumber: null };
    }

    return {
      isValid: true,
      matchedSuppliers,
      supplierName: matchedSuppliers.length === 1 ? matchedSuppliers[0] : null,
      serialNumber: extractSerialNumber(barcode, matchedRules),
    };
  };

  return {
    processBarcode,
  };
};
